// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"k4-z","colorTextValue":"l4-z","swatches":"m4-z","collapseLink":"n4-z","isCollapsed":"o4-z","dropdown":"p4-z","disabled":"q4-z"};